module.exports = __webpack_public_path__ + "img/text.f577f6f4.png";